
import en from './en';
import es from './es';
import fr from './fr';
import de from './de';
import zh from './zh';
import ja from './ja';
import ko from './ko';
import pt from './pt';

const translations: Record<string, Record<string, string>> = {
  en,
  es,
  fr,
  de,
  zh,
  ja,
  ko,
  pt
};

export default translations;
